export const PATHS = [
  {
    layout: 'success',
    fwr: 'react',
    urlResource: 'https://micuenta.pichincha.com/onb-mfa-summary/remoteEntry.js',
    scope: ':product/:flow/:client/exito',
    name: 'mf_success_app',
    type: 'script',
    exposedModule: './react-success',
    guards: ['loggedIn', 'authenticated', 'urlValidated', 'formCompleted'],
  },
  {
    layout: 'otp',
    fwr: 'react',
    urlResource: 'https://micuenta.pichincha.com/onb-mfa-otp/remoteEntry.js',
    scope: ':product/:flow/:client/otp',
    name: 'mf_otp_app',
    type: 'script',
    exposedModule: './react-otp',
    guards: ['loggedIn', 'authenticated', 'urlValidated', 'formCompleted'],
  },
  {
    layout: 'facephi',
    fwr: 'react',
    urlResource: 'https://micuenta.pichincha.com/onb-mfa-facephi/remoteEntry.js',
    scope: ':product/:flow/:client/foto',
    name: 'mf_facephi_app',
    type: 'script',
    exposedModule: './react-facephi',
    guards: ['loggedIn'],
  },
  {
    layout: 'controlList',
    fwr: 'react',
    urlResource: 'https://micuenta.pichincha.com/onb-mfa-url-validation/remoteEntry.js',
    scope: ':product/:flow/:client/validacion',
    name: 'mf_url_app',
    type: 'script',
    exposedModule: './react-url',
    guards: ['loggedIn', 'authenticated'],
  },
  {
    layout: 'firc',
    fwr: 'react',
    urlResource: 'https://micuenta.pichincha.com/onb-mfa-firc/remoteEntry.js',
    scope: ':product/:flow/:client/firc',
    name: 'mf_firc_app',
    type: 'script',
    exposedModule: './react-firc',
    guards: ['loggedIn', 'authenticated', 'urlValidated'],
  },
  {
    layout: 'fiscal',
    fwr: 'react',
    urlResource: 'https://micuenta.pichincha.com/onb-mfa-tax-residence/remoteEntry.js',
    scope: ':product/:flow/:client/fiscal',
    name: 'mf_fiscal_app',
    type: 'script',
    exposedModule: './react-tax-residence',
    guards: ['loggedIn', 'authenticated', 'urlValidated'],
  },
  {
    layout: 'login',
    fwr: 'react',
    urlResource: 'https://micuenta.pichincha.com/onb-mfa-login/remoteEntry.js',
    scope: ':product/:flow',
    name: 'mf_login_app',
    type: 'script',
    exposedModule: './react-login',
    guards: [],
  },
]
